module.exports = __webpack_public_path__ + "img/go.a6526edb.svg";